<template>
	<v-tooltip
		max-width="500px"
		:disabled="tooltipText === ''"
	>
		<template v-slot:activator="{ props }">
			<a
				:href="documentationLink"
				target="_blank"
				class="doc-icon-link"
				v-bind="props"
			>
				<Help16 class="sgnl-icon-color-secondary" />
			</a>
		</template>
		{{ tooltipText }}
	</v-tooltip>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Help16 from "@carbon/icons-vue/es/help/16";

export default defineComponent({
	name: "DocumentationIcon",
	components: { Help16 },
	props: {
		tooltipText: { type: String, default: "" },
		documentationLink: { type: String, required: true, default: "https://docs.signaloid.io" },
	},
});
</script>

<style lang="scss" scoped>
.doc-icon-link {
	display: inline-flex;
	align-items: center;
}
</style>
